import { ROOT_MEDIA } from 'shared-base';

export const characters: ISceneItems = {
  c1: {
    id: 'c1',
    generatorId: 'C-002',
    position: [1.5, 0.3, 2.2],
    rotation: [0, 0, 0],
    scale: 0.016,
    url: `${ROOT_MEDIA}/characters/C-002.fbx`,
  },
};
